<template>
  <div>
    <el-card class="elCard">
      <h1 class="title">费用管理详情</h1>
      <div class="content">
        <el-row type="flex" justify="center" class="elRow">
          <el-col :span="6">
            <span class="colTitle"> 客户名称：</span>
            <span>{{costDetail.enterpriseName}}</span>
          </el-col>
          <el-col :span="6">
            <span class="colTitle">迪链号：</span><span>{{costDetail.businessId}}</span></el-col
          >
        </el-row>
        <el-row type="flex" justify="center" class="elRow">
          <el-col :span="6">
            <span class="colTitle">收费编号：</span><span>{{costDetail.mxid}}</span></el-col
          >
          <el-col :span="6">
            <span class="colTitle">收费金额(含税)：</span> <span>{{$utif.moneyFLoatFormat(costDetail.je)}}</span></el-col
          >
        </el-row>
        <el-row type="flex" justify="center" class="elRow">
          <el-col :span="6">
            <span class="colTitle">收费币种：</span> <span>人民币</span></el-col
          >
          <el-col :span="6">
            <span class="colTitle">收费日期：</span> <span>{{costDetail.sfsj}}</span></el-col
          >
        </el-row>
        <el-row type="flex" justify="center" class="elRow">
          <el-col :span="6">
            <span class="colTitle">开票状态：</span> <span>{{costDetail.isnotInvoice}}</span></el-col
          >
          <el-col :span="6">
            <span class="colTitle">收费环节：</span> <span>{{costDetail.sfhj}}</span></el-col
          >
        </el-row>

        <el-row type="flex" justify="center" class="elRowBack">
          <el-button type="primary" @click="goBack">返回</el-button>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      costDetail: {},
    };
  },
  methods: {
    goBack() {
      this.$router.back();
      localStorage.setItem('costManageNum',2)
    },

    getDtail(params) {
     
      this.$POST("op/feemanage/feedetailquery", params).then((res) => {
        
        if (res.ret=='0') {
          res.data.sfhj = res.data.sfhj=="ZD"?"转单":"融资"
          const status = ['未开票','开票中','已开票','开票失败']
          res.data.isnotInvoice =status[res.data.isnotInvoice]
          res.data.sfsj = this.time2date(res.data.sfsj)
         this.costDetail =res.data
        } else {
          // this.$message.warning(res.msg)
        }
      });
    },
  },
  created() {
    console.log(this.$route.params.row);
    const param = {
      "mxid":this.$route.params.row.mxid
    }
    this.getDtail(param)
  },
};
</script>

<style lang="less" scoped>
.elCard {
  width: 100%;
  height: 500px;
  .title {
    font-size: 24px;
    color: #2e2f3c;
    margin-bottom: 20px;
    margin-left: 30px;
  }
  .content {
    width: 100%;
    font-size: 18px;
    .elRow {
      margin: 10px auto;
      .colTitle {
        padding-right: 30px;
      }
    }
    .elRowBack {
      margin-top: 50px;
    }
  }
}
</style>